import { SET_USERS_DATA } from '../actions/action';

const initialState = {
  usersData: []
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERS_DATA:
      return {
        ...state,
        usersData: action.payload.usersData
      };
    default:
      return state;
  }
};

export default usersReducer;
